import VeiculoNovo from './VeiculoNovo';

export default VeiculoNovo;